import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Switch,
  FormControlLabel,
  Container,
  Paper,
} from '@mui/material';
import TopNavBar from '../../Components/TopNavigation/TopNavBar';
import { request } from '../../Utils/request';
import { RootState } from '../../store/rootReducers';
import { useSelector } from 'react-redux';

interface ApiResponse {
  success?: boolean;
  data?: any;
  message?: string;
}

const AccountPrivacy: React.FC = () => {
  const [isPrivateAccount, setIsPrivateAccount] = useState(false);
  const currentUser = useSelector((state: RootState) => state.user.user);

  const handlePrivateAccountToggle =async (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsPrivateAccount(event.target.checked);
    const id = currentUser.id || currentUser._id
    const profileData ={type:event.target.checked ? 'private':'public'}
    const response = await request<ApiResponse>(`/profile/${id}`, {
      method: 'PUT',
      body: profileData,
      authorization: true,
    });
    console.log('-------profile privacy ',response.message);
    
  };

  useEffect(()=>{
    if(currentUser.type === "public"){
      setIsPrivateAccount(false)
    }else{
      setIsPrivateAccount(true)

    }

  },[])
  return (
    <Box sx={{ 
      display: 'flex',
      flexDirection: 'column'
    }}>
      <TopNavBar title="Account privacy" canGoBack />
      
      <Container maxWidth="sm" sx={{ flex: 1, py: 2 }}>
        <Box 
          sx={{ 
            p: 3,
          }}
        >
          {/* Private Account Toggle */}
          <Box sx={{ mb: 3 }}>
            <FormControlLabel
               label={
                 <Typography 
                   variant="body1" 
                   sx={{ 
                     fontWeight: 500,
                     color: '#49454F',
                     ml: 1
                   }}
                 >
                   Private account
                 </Typography>
               }
               control={
                 <Switch
                 size='medium'
                   checked={isPrivateAccount}
                   onChange={handlePrivateAccountToggle}
                   sx={{
                     '& .MuiSwitch-switchBase.Mui-checked': {
                       color: '#008387',
                       '& + .MuiSwitch-track': {
                         backgroundColor: '#008387',
                       },
                     },
                     '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                       backgroundColor: '#008387',
                     },
                   }}
                 />
               }
               sx={{ 
                 alignItems: 'center',
                 m: 0,
                 width: '100%',
                 justifyContent: 'space-between',
                 flexDirection: 'row-reverse'
               }}
            />
          </Box>

          {/* Privacy Policy Placeholder */}
          <Box sx={{ mt: 4 }}>
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#9E9E9E',
                fontStyle: 'italic',
                lineHeight: 1.6
              }}
            >
              Privacy policy needs to be added here, consider this as a placeholder.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default AccountPrivacy;
